<template>
  <div class="flex-col align-center">
    <div class="banner">
      <img
        style="width: 100%; height: 100%"
        src="../../static/home/banner2.png"
      />
      <div class="center-view">
        <div class="input-view">
          <el-input
            v-model="keyword"
            @keyup.enter.native="search"
            style="flex: 1; border: none"
            placeholder="請輸入書籍名稱作家等檢索"
          />
          <div
            @click="search"
            style="
              width: 50px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-left: 1px solid #ebebeb;
              margin-left: 10px;
            "
          >
            <i class="searchIcon el-icon-search"></i>
          </div>
        </div>
        <img
          style="width: 60%; height: 100%"
          src="../../static/home/icon_hw.png"
        />
        <el-button
          @click="search"
          style="
            margin-top: 15px;
            width: 78px;
            height: 30px;
            padding: 0px;
            background-color: #aa1d1f;
            border: none;
            color: white;
          "
        >
          高級檢索
        </el-button>
        <img
          style="width: 37px; height: 100%; margin-top: 150px"
          src="../../static/home/icon_sb.png"
        />
      </div>
    </div>

    <el-row
      :style="{
        justifyContent: list.length > 3 ? 'flex-end' : '',
      }"
      style="width: 85%; margin-top: 2rem; display: flex; flex-wrap: wrap"
    >
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          margin-bottom: 10px;
          margin-right: 10px;
        "
      >
        <el-image
          style="width: 363px; height: 357px"
          src="../../static/home/homelogobg.png"
        />
        <el-image
          style="width: 40%; position: absolute"
          src="../../static/home/home_logo.png"
        />
      </div>
      <!-- <router-link :to=""> -->
      <el-image
        @click="clickImage(item)"
        v-for="(item, index) in list"
        :key="index"
        style="
          width: 268px;
          height: 357px;
          margin-bottom: 10px;
          background-color: #ebebeb;
          margin-right: 10px;
        "
        fit="scale-down"
        :src="url + item.coverImageUrl"
      />
      <!-- </router-link> -->
    </el-row>
    <el-button
      @click="advancedSearch"
      round
      style="
        margin-top: 30px;
        width: 90px;
        height: 30px;
        padding: 0px;
        border-color: #aa1d1f;
        color: #aa1d1f;
        margin-bottom: 30px;
      "
    >
      查看更多
    </el-button>
  </div>
</template>
<script>
import {
  bookList
} from '@/api/index.js'
export default {
  data () {
    return {
      list: [],
      // url: 'http://47.106.169.20:8084/api-biz',
      url: window.__baseUrl__,
      keyword: '',
      constants: {},
    }
  },
  mounted () {
    bookList({
      pageSize: 1000,
      pageNum: 1,
      isTop: 'Y',
    }).then((res) => {
      this.list = res.rows
    })
  },
  methods: {
    clickImage (item) {
      this.$router.push({
        path: '/view',
        query: {
          id: item.bookId,
          page: 1
        }
      })
    },
    search: function () {
      this.$router.push({
        path: '/result',
        query: {
          keyword: this.keyword
        }
      })
    },
    advancedSearch: function () {
      this.$router.push({
        path: '/result'
      })
    },
  },
};
</script>

<style scoped lang="less">
.banner {
  position: relative;
  display: flex;
  justify-content: center;
}

/deep/.el-input__inner {
  border: none;
  height: 50px;
}

.input-view {
  width: 550px;
  background-color: white;
  display: flex;
  border-radius: 100px;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
}

.center-view {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 9rem;
}

@media screen and (max-width: 768px) {
  .input-view {
    width: 60vw;
  }

  /deep/.el-input__inner {
    height: 35px;
  }

  .center-view {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    top: 3.5rem;
  }
}

.searchIcon {
  color: #ebebeb;
  font-size: 22px;
}

.searchIcon:hover {
  cursor: pointer;
  color: #aa1d1f;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue